import { Icon } from '../icons/Icon.js';

type Chip = { ok: boolean; title: string; desc: string };

type Props = { chips: ReadonlyArray<Chip> };

export function ConfigHealth({ chips }: Props) {
  return (
    <div className="health-row">
      {chips.map((c, i) => (
        <div key={i} className={'health-chip ' + (c.ok ? 'ready' : 'warn')}>
          <Icon name={c.ok ? 'checkCircle' : 'warning'} size={18} />
          <div>
            <div className="health-t">{c.title}</div>
            <div className="health-d">{c.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
